import { createSelector } from 'reselect'

const getOrder = (state) => state.order;
const identity = (state) => state;

export const makeMapStateToProps = (selectors) =>  {
  const computedSelectors = Object.keys(selectors).reduce((acc,key)=>({...acc,[key]:selectors[key]()}),{});
  return (stateToProps) => stateToProps(computedSelectors)
};


export const getItems = () => createSelector(
  [getOrder,identity],
  (order,keys)=> (order.map(id=>keys[id]))
);

export const getReportKeyImages = createSelector(
  [getItems()],
  (items)=>items.filter(_=>!_.deleted && (_.resourceUID ||  _.file))
)

export const isUploadingKeyImages = createSelector(
  [getReportKeyImages],
  (items)=>items.filter(_=>_.uploadStatus).length>0
)

export const getDeletedReportKeyImages = createSelector(
  [getItems()],
  (items)=>items.filter(_=>_.deleted)
)


export const getPatientName = createSelector(
  [({reportBasicInfos})=>reportBasicInfos,({dicomInfo})=>dicomInfo],
  (basicInfo,dicomInfo)=> {
    return (basicInfo.order.map(id=>basicInfo[id]).find(info=>info.dicomField === "patientname") || {}).value || dicomInfo.patientname
  }
);

export const getPatientNameStudyNotes = createSelector(
  [({studyNotes})=>studyNotes.basicInfos,({dicomInfo})=>dicomInfo],
  (basicInfo,dicomInfo)=> {
    return (basicInfo.order.map(id=>basicInfo[id]).find(info=>info.dicomField === "patientname") || {}).value || dicomInfo.patientname
  }
);

export const getEmptyFields = createSelector(
  [getItems()],
  (fields) => {
    const htmlTest = document.createElement('span')
    return fields.filter(field => {
      htmlTest.innerHTML = (field.value||'')
      return !(htmlTest.textContent|| '').trim()
    }).map(_=>_.id)
  }
)


export const getEmptyBasicInfos = createSelector(
  [getItems()],
  (basicInfos) => basicInfos.filter(basicInfo => !(basicInfo.value||'').toString().trim()).map(_=>_.id)
)

export const getFields = getItems()
export const getBasicInfos = getItems()


export const getNewId = () => createSelector(
  [getOrder],
  (order)=> order.reduce((acc,id)=> Math.max(id,acc) ,-1) + 1
);

export const getSelectedTemplate = createSelector(
  [(state)=>state.templates.selected,(state)=>state.templates.available],
  (selected,available) => available.find(t=> String(t.templateId) === String(selected)) || {label:'Custom'}
);


// WEBPACK FOOTER //
// ./~/report-components/src/selectors/index.js